import React from 'react';
import { SectionProps } from '../types';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionMessage from '../shared/SectionMessage';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { Icon } from 'antd';
import HowToFix from '../shared/HowToFix';

export default function CommonKeywordsUsageSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {result.in_title || result.in_description || result.keywords_usage ? (
                    <KeywordsUsageResult
                        inTitle={result.in_title}
                        inDescription={result.in_description}
                        keywordsUsage={result.keywords_usage}
                    />
                ) : (
                    <>
                        {result.how_to_fix && (
                            <HowToFix
                                title={title}
                                howToFix={result.how_to_fix}
                                howToFixVideo={result.how_to_fix_video}
                            />
                        )}
                    </>
                )}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                        render={(result) => (
                            <>
                                {(result.in_title || result.in_description || result.keywords_usage) && (
                                    <KeywordsUsageResult
                                        inTitle={result.in_title}
                                        inDescription={result.in_description}
                                        keywordsUsage={result.keywords_usage}
                                    />
                                )}
                            </>
                        )}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type KeywordsUsageResultProps = {
    inTitle?: any;
    inDescription?: any;
    keywordsUsage?: {
        [keyword: string]: {
            title: boolean;
            description: boolean;
            headings: boolean;
        };
    };
};

function KeywordsUsageResult({ inDescription, inTitle, keywordsUsage }: KeywordsUsageResultProps) {
    return (
        <>
            {inTitle && inDescription && (
                <div>
                    <div className="description-meta">{inTitle}</div>
                    <div className="description-meta">{inDescription}</div>
                </div>
            )}

            {keywordsUsage && (
                <div className="stats-table-container">
                    <header>
                        <div className="col">Keyword</div>
                        <div className="col center">Title tag</div>
                        <div className="col center">Meta description</div>
                        <div className="col center">Headings</div>
                    </header>

                    {Object.keys(keywordsUsage).map((keyword, idx) => {
                        const item = keywordsUsage[keyword];

                        return (
                            <div
                                className="row"
                                key={idx}
                            >
                                <div className="col">{keyword}</div>
                                <div className="col center">
                                    <Icon
                                        type={item.title ? 'check' : 'close'}
                                        className={item.title ? 'passed' : 'failed'}
                                    />
                                </div>
                                <div className="col center">
                                    <Icon
                                        type={item.description ? 'check' : 'close'}
                                        className={item.description ? 'passed' : 'failed'}
                                    />
                                </div>
                                <div className="col center">
                                    <Icon
                                        type={item.headings ? 'check' : 'close'}
                                        className={item.headings ? 'passed' : 'failed'}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </>
    );
}
